import React from "react";

interface Branch {
  clinicName: string;
  subDistrictOrCity?: string;
  state?: string;
  address?: string;
  pincode?: string;
}

interface Props {
  branch?: Branch;
}

const ClinicDetailsCard: React.FC<Props> = ({ branch }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow mb-6">
      <h2 className="font-bold text-xl mb-2">
        At - {branch?.clinicName}
      </h2>

      <p className="text-sm">{branch?.subDistrictOrCity}</p>
      {branch?.state && <p className="text-sm">{branch.state}</p>}
      {branch?.address && <p className="text-sm mt-2">{branch.address}</p>}
      {branch?.pincode && <p className="text-sm">{branch.pincode}</p>}
    </div>
  );
};

export default ClinicDetailsCard;
